module.exports = __webpack_public_path__ + "img/launcher-icon-4x.d0c6fbe2.png";